import { layout34, layout34Components } from './v34/layout';
import { layout40, layout40Components } from './v40/layout';
import { layoutInspectionless1, layoutInspectionless1Components } from './inspectionless_v1/layout'
import { layoutInspectionless11, layoutInspectionless11Components } from './inspectionless_v11/layout'

export enum SchemaDictionaryNames {
	'InspectionReport:3.4' = 'v34',
	'InspectionReport:4' = 'v40',
	'Inspectionless:1' = 'inspectionless_v1',
	'Inspectionless:1.1' = 'inspectionless_v11',
}

export const LAYOUTS = {
	'v34': layout34,
	'v40': layout40,
	'inspectionless_v1': layoutInspectionless1,
	'inspectionless_v11': layoutInspectionless11
};

export const COMPONENTS = {
	'v34': layout34Components,
	'v40': layout40Components,
	'inspectionless_v1': layoutInspectionless1Components,
	'inspectionless_v11': layoutInspectionless11Components
}
